export default __webpack_public_path__ + "un-changed-pink-icon.svg";